/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { Button, SelectGeneric, Toggle } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

import { initialFilters } from '../../hooks/useFilters';
import { getPositionsByContract } from '../../../../services/adminContracts';
import {
  fetchDataTeam,
  fetchServices
} from '../../../../page/ServiceRequest/FilterServiceRequest/ContentFilter/helpers/filtersFetcher';
import PositionLineContainer from '../../../PositionLineContainer/PositionLineContainer';
import { ubicationTypeEnum } from '../../../../utils/dataStatus';
import { ACTIVE_KEY, LOCATION_TYPE_KEY, OPTION_PARTES } from '../../utils/consts';
import {
  fetchAprooverContracts,
  fetchInspectorContracts,
  fetchLocations,
  fetchProveedores,
  fetchProvidersForAproover
} from '../../utils/customFetchFunctions';
import { usePositionLineForm } from '../../hooks';
import useToast from '../../../../hooks/useToast';
import { tryCatchMaker } from '../../../../utils/globalFunctions';
import { filtersAdapterToSave } from '../../../../adapters/weekly-report/filters-adapter';
import { saveFilters } from '../../../../services/userFilterServices';
import useFilterParams from '../../hooks/useFilterParams';
import DateInputCalendar from '../../../Calendar/DateInputCalendar/DateInputCalendar';

import styles from './WeeklyReportFilters.module.scss';

/**
 * @typedef Props
 * @property {import("../../../../adapters/weekly-report/weekly-report-calendar-adapter").TableDataCalendar} calendar
 * @property {() => void} cleanFilters
 * @property {boolean} isInspector
 * @property {import('../../hooks/useFilters').Filters} filters
 * @property {(newFilters: import('../../hooks/useFilters').Filters) => void} updateFilters
 */

/** @param {Props} */
const WeeklyReportFilters = ({
  calendar,
  cleanFilters,
  filters,
  isInspector,
  updateFilters,
  setShowFilters
}) => {
  const { ubicationTypeSelect, events, workPartStatus, userBusinessUnits } = useFilterParams(
    isInspector,
    // This true it's for include generic ubication
    true
  );
  const { setNewToast } = useToast();
  const [formData, setFormData] = useState(filters);
  const [ubicationTypeOptions, setUbicationTypeOptions] = useState([]);
  const [workpartFilter, setWorkpartFilter] = useState(filters.partesVisualizar);
  const [positionOptions, setPositionOptions] = useState([]);
  const currentContractsSelected = useMemo(
    () => formData.contratosIds?.map((e) => e.nombre),
    [formData.contratosIds]
  );

  const {
    handlePositionLineChange,
    resetPositionAndLineFields,
    addPositionLine,
    deletePositionLine,
    resetPositionLineChips,
    positionLine,
    linesOptions,
    position,
    line
  } = usePositionLineForm({
    filters: formData,
    currentContractsSelected
  });

  useEffect(() => {
    setFormData(filters);
  }, [filters]);

  useEffect(() => {
    setUbicationTypeOptions(ubicationTypeSelect.filter((e) => e.id !== ubicationTypeEnum.locacion));
  }, [ubicationTypeSelect, setNewToast]);

  useEffect(() => {
    if (formData.contratosIds?.length) {
      getPositionsByContract(currentContractsSelected).then((data) => {
        setPositionOptions(data);
      });
    }
  }, [formData.contratosIds]);

  /**
   * @param {import('react').FormEvent<HTMLFormElement>} event
   * @returns {({import('../../hooks/useFilters').Filters}) => void}
   */
  const handleOnSubmit = (event) => {
    event.preventDefault();
    updateFilters({
      ...formData,
      posicionesLineas: positionLine
    });
    setShowFilters((oldValue) => !oldValue);
  };

  /**
   * @param {keyof import('../../hooks/useFilters').Filters} key
   * @returns {(newValue: typeof VIEW_OPTIONS[number]) => void}
   */
  const handleOnChange = (key, newValue) => {
    // *Cleaning validation for location input when changing the fields locationType or active
    if (key === LOCATION_TYPE_KEY || key === ACTIVE_KEY) {
      setFormData((state) => ({
        ...state,
        ubicacionesIds: [],
        [key]: newValue
      }));
    } else {
      setFormData((state) => ({
        ...state,
        [key]: newValue
      }));
    }
  };

  const onClean = () => {
    cleanFilters();
    setFormData(initialFilters);
    setWorkpartFilter(true);
  };

  const onSave = async () => {
    const formatedFilters = filtersAdapterToSave(
      { ...formData, posicionesLineas: positionLine },
      isInspector
    );

    updateFilters({ ...formData, posicionesLineas: positionLine });

    saveFilters(formatedFilters)
      .then(() => {
        setNewToast({
          type: 'SUCCESS',
          message: 'Filtros guardados con éxito.'
        });
      })
      .catch((err) => {
        setNewToast({
          type: 'ERROR',
          message: err.message
        });
      });
  };

  const fetchProviders = (value) => {
    let promise;

    if (isInspector) {
      promise = () => fetchProveedores(value, formData?.contratosIds);
    } else {
      promise = () => fetchProvidersForAproover(value, formData?.contratosIds);
    }

    return tryCatchMaker({
      promise,
      defaultValue: [],
      setNewToast
    });
  };

  const fetchContracts = (value) => {
    const promise = isInspector
      ? () => fetchInspectorContracts(value, formData?.idsProveedores)
      : () => fetchAprooverContracts(value, formData?.idsProveedores);

    return tryCatchMaker({
      promise,
      defaultValue: [],
      setNewToast
    });
  };

  const handleWorkpartFilterSwitch = (e) => {
    setWorkpartFilter(e);
    setFormData((state) => ({ ...state, partesVisualizar: e }));
  };

  const areDatesSetted = !(formData.fechaDesde && formData.fechaHasta);

  return (
    <form className={`mt-4 mx-2 ${styles['filter-container']}`} onSubmit={handleOnSubmit}>
      <Row className="d-flex gap-1">
        <Col>
          <DateInputCalendar
            arrayDate={calendar?.pendingDates}
            handleChangeDate={(newDate) =>
              setFormData((prev) => ({ ...prev, fechaDesde: newDate }))
            }
            label="Desde"
            maxDate={formData.fechaHasta}
            selectDay={formData.fechaDesde}
          />
        </Col>
        <Col>
          <DateInputCalendar
            arrayDate={calendar?.pendingDates}
            handleChangeDate={(newDate) =>
              setFormData((prev) => ({ ...prev, fechaHasta: newDate }))
            }
            label="Hasta"
            minDate={formData.fechaDesde}
            selectDay={formData.fechaHasta}
          />{' '}
        </Col>
        {areDatesSetted && <span className={styles['date-filter-alert']}>Campos obligatorios</span>}
      </Row>
      <Toggle
        className="d-flex justify-content-between pb-2"
        label="Partes a Visualizar"
        name="partesVisualizar"
        onChange={handleWorkpartFilterSwitch}
        options={OPTION_PARTES}
        type="radio"
        value={workpartFilter}
      />
      <SelectGeneric
        async
        fetchData={(value) => fetchProviders(value)}
        isMulti
        label="Proveedores"
        name="idsProveedores"
        noOptionsMessage="Ingresar al menos 3 caracteres"
        onChange={(newValue) => handleOnChange('idsProveedores', newValue)}
        placeholder="Buscar proveedor"
        showIcon
        value={formData.idsProveedores}
        withSelect="100%"
      />
      <SelectGeneric
        async
        fetchData={(value) => fetchContracts(value)}
        isMulti
        label="Contratos"
        name="contratosIds"
        noOptionsMessage="Ingresar al menos 3 caracteres"
        onChange={(newValue) => {
          if (newValue) resetPositionAndLineFields();
          if (newValue?.length === 0) resetPositionLineChips();
          handleOnChange('contratosIds', newValue);
        }}
        placeholder="Buscar contrato"
        showIcon
        value={formData.contratosIds}
        withSelect="100%"
      />
      <>
        <Row>
          <Col sm={4}>
            <SelectGeneric
              defaultValueOneOption={false}
              isDisabled={Boolean(!formData.contratosIds?.length)}
              label="Posición"
              name="position"
              onChange={(newValue) => handlePositionLineChange('position', newValue)}
              options={positionOptions}
              placeholder="--"
              showIcon
              value={position}
              withSelect="100%"
            />
          </Col>
          <Col sm={4}>
            <SelectGeneric
              defaultValueOneOption={false}
              isDisabled={Boolean(!position)}
              label="Linea"
              name="line"
              onChange={(newValue) => handlePositionLineChange('line', newValue)}
              options={linesOptions}
              placeholder="--"
              showIcon
              value={line}
              withSelect="100%"
            />
          </Col>
          <Col className={styles['add-position-line-button']} sm={4}>
            <Button
              disabled={!(position && line)}
              label="Agregar"
              onClick={addPositionLine}
              type="button"
              variant="primary"
              widthButton="100%"
            />
          </Col>
        </Row>
        <PositionLineContainer
          contractsSelected={currentContractsSelected}
          deletePositionLine={deletePositionLine}
          positionLine={positionLine}
        />
      </>
      <SelectGeneric
        clearable
        label="Tipo de ubicación"
        name="tipoUbicacionId"
        onChange={(newValue) => handleOnChange('tipoUbicacionId', newValue)}
        options={ubicationTypeOptions}
        placeholder="Selecciona tipo de ubicacion"
        showIcon
        value={formData.tipoUbicacionId}
        withSelect="100%"
      />
      <SelectGeneric
        async
        fetchData={(value) =>
          tryCatchMaker({
            promise: () => fetchLocations(value, formData?.tipoUbicacionId, userBusinessUnits),
            defaultValue: [],
            setNewToast
          })
        }
        isDisabled={!formData.tipoUbicacionId}
        isMulti
        label="Ubicación"
        name="ubicacionesIds"
        noOptionsMessage="Ingresar al menos 3 caracteres"
        onChange={(newValue) => handleOnChange('ubicacionesIds', newValue)}
        placeholder="Selecciona una ubicacion"
        showIcon
        value={formData.ubicacionesIds}
        withSelect="100%"
      />
      <SelectGeneric
        async
        fetchData={(value) => fetchServices(value)}
        isMulti
        label="Servicio"
        name="serviciosIds"
        noOptionsMessage="Ingresar al menos 3 caracteres"
        onChange={(newValue) => handleOnChange('serviciosIds', newValue)}
        placeholder="Buscar servicio"
        showIcon
        value={formData.serviciosIds}
        withSelect="100%"
      />
      <SelectGeneric
        label="Estado del parte"
        name="estadoParteId"
        onChange={(newValue) => handleOnChange('estadoParteId', newValue)}
        options={workPartStatus}
        placeholder="Selecciona un estado"
        showIcon
        value={formData.estadoParteId}
        withSelect="100%"
      />
      <SelectGeneric
        isMulti
        label="Tipo de evento"
        name="idsEventos"
        noOptionsMessage="Ingresar al menos 3 caracteres"
        onChange={(newValue) => handleOnChange('idsEventos', newValue)}
        options={events}
        placeholder="Buscar tipo de evento"
        showIcon
        value={formData.idsEventos}
        withSelect="100%"
      />
      <SelectGeneric
        async
        fetchData={(value) => fetchDataTeam(value)}
        isMulti
        label="Equipos"
        name="idsEquipos"
        noOptionsMessage="Ingresar al menos 3 caracteres"
        onChange={(newValue) => handleOnChange('idsEquipos', newValue)}
        placeholder="Buscar equipo"
        showIcon
        value={formData.idsEquipos}
        withSelect="100%"
      />
      <div className="container-buttons">
        <Button
          label="Limpiar"
          onClick={onClean}
          type="button"
          variant="outline-primary"
          widthButton="90px"
        />
        <Button
          label="Guardar"
          onClick={onSave}
          type="button"
          variant="outline-primary"
          widthButton="90px"
        />
        <Button
          disabled={!(formData.fechaDesde && formData.fechaHasta)}
          label="Buscar"
          type="submit"
          variant="primary"
          widthButton="90px"
        />
      </div>
    </form>
  );
};

export default WeeklyReportFilters;

WeeklyReportFilters.propTypes = {
  calendar: PropTypes.shape({
    firstWeek: PropTypes.shape({
      startDate: PropTypes.string,
      endDate: PropTypes.string
    }),
    lastWeek: PropTypes.shape({
      startDate: PropTypes.string,
      endDate: PropTypes.string
    }),
    pendingDates: PropTypes.arrayOf(PropTypes.string)
  }),
  cleanFilters: PropTypes.func,
  isInspector: PropTypes.bool.isRequired,
  filters: PropTypes.shape({
    contratosIds: PropTypes.arrayOf(PropTypes.number),
    partesVisualizar: PropTypes.bool,
    idsEquipos: PropTypes.arrayOf(PropTypes.number),
    idsEventos: PropTypes.arrayOf(PropTypes.number),
    idsProveedores: PropTypes.arrayOf(PropTypes.number),
    posicionesLineas: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string
      })
    ),
    tipoUbicacionId: PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.number,
      label: PropTypes.string,
      nombre: PropTypes.string,
      tipoNegocio: PropTypes.shape({
        evento: PropTypes.string,
        id: PropTypes.number,
        nombre: PropTypes.string
      })
    }),
    ubicacionesIds: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        value: PropTypes.number,
        label: PropTypes.string,
        nombre: PropTypes.string
      })
    ),
    serviciosIds: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        value: PropTypes.number,
        label: PropTypes.string,
        nombre: PropTypes.string
      })
    )
  }),
  updateFilters: PropTypes.func,
  setShowFilters: PropTypes.func
};

WeeklyReportFilters.defaultProps = {
  calendar: {},
  cleanFilters: () => {},
  filters: {},
  updateFilters: () => {},
  setShowFilters: () => {}
};
